interface Pilot {
    name: string;
    ad_group?: string;
    queue?: string;
}

export const CarePilot: Pilot = {
    name: "care",
    ad_group: "HQDOMAIN_VDI-VZW-TECHCARE-TEST",
};

export const PILOT_AD_GROUP_MAPPINGS = {
    "HQDOMAIN_VDI-VZW-TECHCARE-TEST": CarePilot.name,
} as const;

export type AllowedPilotGroups = keyof typeof PILOT_AD_GROUP_MAPPINGS;
type MappedPilotGroup = (typeof PILOT_AD_GROUP_MAPPINGS)[AllowedPilotGroups];

export function findPilotGroups(groups: string[]): MappedPilotGroup[] {
    if (!Array.isArray(groups)) {
        console.warn("Expected an array, received:", groups);
        return [];
    }
    return groups
        .filter((group): group is AllowedPilotGroups => group in PILOT_AD_GROUP_MAPPINGS)
        .map((group) => PILOT_AD_GROUP_MAPPINGS[group]);
}
